const KeenSlider = window.KeenSlider

const { setInitialised, addWheelControls, useArrows } =
  window.BAO.Carousel.plugins

class SearchCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'BAO::CSS_CAROUSEL::VISIBLE', this.handleVisible, {
      once: true,
    })
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    const plugins = [setInitialised(), addWheelControls('horizontal')]

    if (this.els.arrows?.exists) {
      if (this.els.slide.elements.length > 2) {
        this.els.arrows.element.removeAttribute('aria-hidden')

        plugins.push(
          useArrows({
            next: this.els?.next?.element,
            previous: this.els?.previous?.element,
          }),
        )
      } else {
        this.els.arrows.element.setAttribute('aria-hidden', true)
      }
    }

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1000,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 'auto',
          spacing: 8,
        },
      },
      plugins,
    )
  }

  handleVisible () {
    requestAnimationFrame(() => {
      this.carousel = this.setupCarousel()
    })
  }
}

if (!customElements.get('search-carousel')) {
  customElements.define('search-carousel', SearchCarousel)
}
